<template>
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <!-- 友情链接区域 -->
          <div class="friend-link-block">
            <span class="friend-title">{{ $t("footer.friendLink") }}：</span>
            <div class="friend-link-list">
              <a href="https://en.bjtu.edu.cn/" target="_blank">{{ $t("footer.bjtu") }}</a>
              <a href="https://english.imech.ac.cn/" target="_blank">{{ $t("footer.imech") }}</a>
              <a href="https://en.swjtu.edu.cn/index.jsp" target="_blank">{{ $t("footer.swjtu") }}</a>
              <a href="https://en.cstam.org.cn/" target="_blank">{{ $t("footer.cstam") }}</a>
            </div>
          </div>

          <div class="copyright-center">
            <span class="copyright-text">Copyright @ 2012-2020 www.cis.org.cn All rights reserved.</span>
            <span class="divider">|</span>
            <img src="@/assets/images/gongan-logo.png" alt="公安备案标识" class="gongan-logo" />
            <span class="beian-text">
              <a style="margin-left: 2px;" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802021154" target="_blank">京公网安备 11010802021154号</a>
              <a style="margin-left: 12px;" href="https://beian.miit.gov.cn" target="_blank">京ICP备07501742</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import profileService from '@/utils/profileService';
export default {
  props: {
    darkClass: {
      type: Object,
    },
  },
  components: {},
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    news: [],
    dialogVisible: false,
    email: '',
    showEmailError: false,
    emailErrorMsg: ''
  }),
  computed: {
    userProfile() {
      return profileService.getProfile();
    }
  },
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.news = Array.isArray(this.dataWrapper.articles)
            ? this.dataWrapper.articles.filter(item => item.recommend === true).slice(0, 6)
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleSubmit() {
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email) {
        this.showEmailError = true;
        this.emailErrorMsg = '请输入邮箱地址';
        return;
      } else if (!emailReg.test(this.email)) {
        this.showEmailError = true;
        this.emailErrorMsg = '请输入正确的邮箱格式';
        return;
      } else {
        this.showEmailError = false;
      }

      if (!this.userProfile || !this.userProfile.id) {
        this.dialogVisible = true;
      } else {
        const token = localStorage.getItem('token');
        if (token) {
          this.handleProfilePage(token);
        }
      }
    },
    async handleProfilePage(token) {
      if (token) {
        this.$router.push({
          name: 'Profile',
          query: { tab: '1', email: this.email }
        });
      }
    },
  }
};
</script>


<style scoped>
.footer-copyright {
  background-color: #555555;
  padding: 24px 12px;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.5;
}

/* 友情链接样式 */
.friend-link-block {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
  gap: 6px 10px;
}
.friend-title {
  color:#fff;
}
.friend-link-list {
  display:flex;
  align-items:center;
  flex-wrap:wrap;
  gap: 0 14px;
}
.friend-link-list a {
  color: rgb(116, 154, 227);
  text-decoration: none;
}
.friend-link-list a:hover {
  text-decoration: underline;
}

.copyright-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
  text-align: center;
}

.copyright-text {
  white-space: nowrap;
}

/* 仅保留版权文字与国徽之间的分隔线 */
.divider {
  color: #fff;
  opacity: 0.7;
  margin: 0 12px;
}

.gongan-logo {
  height: 16px;
  width: auto;
  flex-shrink: 0;
}

.beian-text {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.copyright-center a {
  color: rgb(116, 154, 227) !important;
  text-decoration: none;
}

/* 移动端：垂直排列，隐藏所有竖线分隔符 */
@media screen and (max-width: 768px) {
  .copyright-center {
    flex-direction: column;
    gap: 10px;
  }
  .divider {
    display: none;
  }
  .beian-text {
    justify-content: center;
  }
  .friend-link-block {
    flex-direction:column;
  }
}
</style>